import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getKnowledgeBases } from '../../../app/services/apiEndpoints';

interface IFetchKBPayload {
  groups: string;
}

export const fetchKnowledgeBases = createAsyncThunk(
  'kb/fetchKnowledgeBases',
  async (payload: IFetchKBPayload, thunkAPI) => {
    try {
      const queryParams = new URLSearchParams({
        groups: payload.groups
      });
      const response = await getKnowledgeBases(queryParams);
      return response;
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : "An unknown error occurred";
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);

export const fetchAllKnowledgeBases = createAsyncThunk(
  'kb/fetchAllKnowledgeBases',
  async (payload: IFetchKBPayload, thunkAPI) => {
    try {
      const queryParams = new URLSearchParams({
        groups: payload.groups
      });
      const response = await getKnowledgeBases(queryParams);
      return response;
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : "An unknown error occurred";
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);

interface IKBSettingsState {
  knowledgeBases: any;
  allKnowledgeBasesForThisUser: any;
  selectedKnowledgeBase: any | null;
  scoreThreshold: number;
  hasInteractedWithChat: boolean;
  hrButtonClicked: boolean;
  hrDefaultKB: Record<string, any> | undefined;
  itButtonClicked: boolean;
  itDefaultKB: Record<string, any> | undefined;
  error: any | null;
  fileListButtonDisabled: boolean;
}

const initialState: IKBSettingsState = {
  knowledgeBases: [],
  allKnowledgeBasesForThisUser: [],
  selectedKnowledgeBase: null,
  scoreThreshold: 0.5,
  hasInteractedWithChat: false,
  hrButtonClicked: false,
  hrDefaultKB: undefined,
  itButtonClicked: false,
  itDefaultKB: undefined,
  error: null,
  fileListButtonDisabled: true,
};

const KBSlice = createSlice({
  name: 'knowledge-base',
  initialState,
  reducers: {
    setKnowledgeBases(state, action) {
      state.knowledgeBases = action.payload;
    },
    setSelectedKnowledgeBase(state, action) {
      state.selectedKnowledgeBase = action.payload;
    },
    setAllKnowledgeBasesForThisUser(state, action) {
      state.selectedKnowledgeBase = action.payload;
    },
    setScoreThreshold(state, action) {
      state.scoreThreshold = action.payload;
    },
    setInteractedWithChat(state, action) {
      state.hasInteractedWithChat = action.payload;
    },
    setHrButtonClicked(state, action) {
      state.hrButtonClicked = action.payload;
    },
    setHrDefaultKB(state, action) {
      state.hrDefaultKB = action.payload;
    },
    setItButtonClicked(state, action) {
      state.itButtonClicked = action.payload;
    },
    setItDefaultKB(state, action) {
      state.itDefaultKB = action.payload;
    },
    setFileListButtonDisabled(state, action) {
      state.fileListButtonDisabled = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchKnowledgeBases.fulfilled, (state, action) => {
        state.knowledgeBases = action.payload;
      })
      .addCase(fetchKnowledgeBases.rejected, (state, action) => {
        state.error = action.payload as string ?? null;
      })
      .addCase(fetchAllKnowledgeBases.fulfilled, (state, action) => {
        state.allKnowledgeBasesForThisUser = action.payload;
      })
      .addCase(fetchAllKnowledgeBases.rejected, (state, action) => {
        state.error = action.payload as string ?? null;
      })
  },
});

export const {
  setKnowledgeBases,
  setSelectedKnowledgeBase,
  setAllKnowledgeBasesForThisUser,
  setScoreThreshold,
  setInteractedWithChat,
  setHrButtonClicked,
  setHrDefaultKB,
  setItButtonClicked,
  setItDefaultKB,
  setFileListButtonDisabled, } = KBSlice.actions
export default KBSlice.reducer;